import { Box, BoxComponentProps, Stack } from "@mantine/core";
import { ReactNode } from "react";

export const LayoutWorkstationHeader = ({
  children,
  header,
  headerHeight = 40,
  ...props
}: {
  children: ReactNode;
  header: ReactNode;
  headerHeight?: number;
} & BoxComponentProps) => {
  return (
    <Stack w={"100%"} h={"100%"} gap={0} {...props}>
      <Box
        h={headerHeight}
        w={"100%"}
        style={{
          borderBottom: "1px solid #ddd",
          overflow: "hidden",
        }}
      >
        {header}
      </Box>
      <Box h={`calc(100% - ${headerHeight}px)`} w={"100%"}>
        {children}
      </Box>
    </Stack>
  );
};
